// Services de cadastro (clientes e veículos), conectados ao backend real
// (tenant-service), sincronizando entre qualquer dispositivo logado na
// mesma oficina. Mantém a mesma interface anterior (list/get/save/remove),
// mas agora todas retornam Promises -- quem consome precisa de await/then.
import API_BASE from "../../config.js";
import { authFetch } from "../../services/authFetch";
import { generateId } from "../lib/id";

const API = `${API_BASE}/api/v1/checklist`;

function makeCrudService(entityName) {
  const endpoint = entityName === "cliente" ? "clientes" : "veiculos";

  return {
    async list(workshopId) {
      try {
        const r = await authFetch(`${API}/${workshopId}/${endpoint}`);
        if (!r.ok) return [];
        const data = await r.json();
        return Array.isArray(data)
          ? data.sort((a, b) => a.nome?.localeCompare(b.nome || "") || 0)
          : [];
      } catch (err) {
        console.error(`Falha ao listar ${entityName}:`, err);
        return [];
      }
    },
    async get(workshopId, id) {
      const lista = await this.list(workshopId);
      return lista.find((i) => i.id === id) || null;
    },
    async save(workshopId, item) {
      const record = item.id ? item : { ...item, id: generateId(entityName) };
      const r = await authFetch(`${API}/${workshopId}/${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(record),
      });
      if (!r.ok) throw new Error(`Erro ao salvar ${entityName}`);
      return record;
    },
    async remove(workshopId, id) {
      const r = await authFetch(`${API}/${workshopId}/${endpoint}/${id}`, { method: "DELETE" });
      if (!r.ok) throw new Error(`Erro ao excluir ${entityName}`);
    },
  };
}

export const clienteService = makeCrudService("cliente");
export const veiculoService = makeCrudService("veiculo");
